<template>
    <div
        v-if="task.completed_at && task.completed_by_user"
        class="flex items-center"
    >
        <div class="text-xs h-xl w-xl bg-neutral-lightest rounded-full inline-flex items-center justify-center font-bold mr-sm">
            {{ task.completed_by_user.initials }}
        </div>
        <span class="text-xs">{{ completedAt }}</span>
    </div>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        props: {
            task: {
                type: Object,
                required: true,
            },
        },
        computed: {
            completedAt() {
                return format(this.task.completed_at, 'YYYY-MM-DD');
            },
        },
    };
</script>
